export default {
    methods: {
        display(fieldName) {
            if (this.$store.state.createShipment.bookingOptions.viewOptions != undefined) {
                var element = this.$store.state.createShipment.bookingOptions.viewOptions.find(
                    (obj) => {
                        return obj.name === fieldName;
                    }
                );

                if (element != undefined) {
                    return element.display;
                }
            }
            return false;
        },

        required(fieldName) {
            if(this.$store.state.createShipment.bookingOptions.viewOptions != undefined) {
                var element = this.$store.state.createShipment.bookingOptions.viewOptions.find(
                    (obj) => {
                        return obj.name === fieldName;
                    }
                );

                if (element != undefined) {
                    return element.required;
                }
            }

            return false;
        }
    }
};
